import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-677cd57b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paste" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "property-header" }
const _hoisted_6 = { class: "field has-addons" }
const _hoisted_7 = { class: "control is-expanded" }
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = { class: "control" }
const _hoisted_10 = ["onClick", "disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-up" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "control" }
const _hoisted_14 = ["onClick", "disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-down" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "control" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MonacoWrapper = _resolveComponent("MonacoWrapper")!
  const _component_PanelAttribute = _resolveComponent("PanelAttribute")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { title: "Snippets" }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: "button is-small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard()))
      }, _hoisted_2),
      _createElementVNode("button", {
        class: "button is-small",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pasteFromClipboard()))
      }, _hoisted_4),
      _createVNode(_component_PanelAttribute, {
        title: "Snippets",
        expandable: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pkgData.snippets, (snippet, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "property",
              key: i
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      class: "input is-small",
                      type: "text",
                      placeholder: "Key",
                      "onUpdate:modelValue": ($event: any) => (snippet.name = $event)
                    }, null, 8, _hoisted_8), [
                      [_vModelText, snippet.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "button is-small",
                      onClick: ($event: any) => (_ctx.up(i)),
                      disabled: _ctx.isUpDisabled(i)
                    }, _hoisted_12, 8, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      class: "button is-small",
                      onClick: ($event: any) => (_ctx.down(i)),
                      disabled: _ctx.isDownDisabled(i)
                    }, _hoisted_16, 8, _hoisted_14)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      class: "button is-small",
                      onClick: ($event: any) => (_ctx.remove(i))
                    }, _hoisted_20, 8, _hoisted_18)
                  ])
                ])
              ]),
              _createVNode(_component_MonacoWrapper, {
                modelValue: snippet.value,
                "onUpdate:modelValue": ($event: any) => (snippet.value = $event),
                adjustToContent: true,
                language: "plaintext"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]))
          }), 128)),
          _createElementVNode("button", {
            class: "button is-small",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.add()))
          }, "Add snippet")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}